import { cn } from '@/shared/utils/cn';
import React, { useState } from 'react';
import { Checkbox } from '@/modules/Checkbox';
import { ListSearchInput } from '../molecules/ListSearchInput';

export interface ListUsersSelectItem {
  id: string;
  name: string;
  avatar?: React.ReactNode;
  selected?: boolean;
}

export interface ListUsersSelectProps {
  users: ListUsersSelectItem[];
  onUserToggle?: (userId: string) => void;
  onDelete?: (userIds: string[]) => void;
  searchPlaceholder?: string;
  deleteButtonLabel?: string;
  className?: string;
}

export const ListUsersSelect: React.FC<ListUsersSelectProps> = ({
  users,
  onUserToggle,
  onDelete,
  searchPlaceholder = 'Buscar...',
  deleteButtonLabel = '🗑️ Borrar Usuario',
  className,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const selectedUsers = users.filter((user) => user.selected);
  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDelete = () => {
    const selectedIds = selectedUsers.map((user) => user.id);
    onDelete?.(selectedIds);
  };

  return (
    <div
      className={cn(
        'ui-rounded-surface-card ui-border ui-border-default ui-bg-fill ui-p-8 ui-shadow-03',
        'ui-flex ui-min-w-[240px] ui-flex-col ui-gap-8',
        className
      )}
    >
      {/* Search Input */}
      <ListSearchInput
        value={searchTerm}
        onChange={setSearchTerm}
        placeholder={searchPlaceholder}
      />

      {/* User List */}
      {filteredUsers.map((user) => (
        <div
          key={user.id}
          onClick={() => onUserToggle?.(user.id)}
          className={cn(
            'ui-flex ui-cursor-pointer ui-items-center ui-gap-8 ui-rounded-control-sm ui-px-8 ui-py-6 ui-transition-all',
            user.selected ? 'ui-bg-fill-hover' : 'hover:ui-bg-fill-hover'
          )}
        >
          {/* Avatar */}
          <div className="ui-flex ui-h-16 ui-w-16 ui-shrink-0 ui-items-center ui-justify-center ui-rounded-control-pill ui-bg-surface-secondary ui-text-body-xs-regular">
            {user.avatar || user.name.substring(0, 1).toUpperCase()}
          </div>

          {/* Name */}
          <span className="ui-flex-1 ui-text-body-sm-regular ui-font-body-sm-medium ui-text-primary">
            {user.name}
          </span>

          {/* Checkbox */}
          <Checkbox
            checked={user.selected || false}
            onChange={() => onUserToggle?.(user.id)}
            size="md"
          />
        </div>
      ))}

      {/* Delete Button */}
      {selectedUsers.length > 0 && (
        <button
          onClick={handleDelete}
          className="ui-h-32 ui-w-full ui-rounded-control-sm ui-bg-surface-danger ui-px-8 ui-py-4 ui-text-body-sm-regular ui-font-body-sm-bold ui-text-danger ui-transition-colors hover:ui-bg-surface-danger-hover"
        >
          {deleteButtonLabel}
        </button>
      )}
    </div>
  );
};
